var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C31.0457 0 40 8.95428 40 20L39.9973 20.3307C39.8207 31.2239 30.9353 40 20 40L19.867 39.9996C15.4799 39.971 11.4287 38.5289 8.1442 36.1073L34.4129 10.1845H26.3735L20.2519 16.1004L17.5428 13.4061H6.80331L14.8281 21.4508L4.06728 32.0889L3.99104 31.9879C1.48542 28.6472 0 24.4973 0 20L0.00267944 19.6693C0.179296 8.77609 9.0648 0 20 0ZM25.8337 21.6066L20.4273 26.8527L23.1123 29.5205L33.8645 29.5225L25.8337 21.6066Z",
    fill: "url(#paint0_radial_6039_1535)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6039_1535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36 3.5) rotate(135) scale(48.7904)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14C5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#0D58EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100E75"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXy);
export default __webpack_public_path__ + "static/media/xy.0e8935784918297dc72920d1e4afa944.svg";
export { ForwardRef as ReactComponent };